import { render, staticRenderFns } from "./BaseTextArea.vue?vue&type=template&id=e82eb3e2&scoped=true"
import script from "./BaseTextArea.vue?vue&type=script&lang=js"
export * from "./BaseTextArea.vue?vue&type=script&lang=js"
import style0 from "./BaseTextArea.vue?vue&type=style&index=0&id=e82eb3e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e82eb3e2",
  null
  
)

export default component.exports